import UUIDBase from '../UUIDBase'

export const accountTemplateI18nMessages = {
  en: {
    id: 'ID',
    enName: 'English Name',
    arName: 'Arabic Name',
    enDescription: 'English Description',
    arDescription: 'Arabic Description',
    code: 'Code',
    accountCategory: 'Account Category',
    accountSubcategory: 'Account Subcategory',
    balance: 'Balance',
    isSharedAccount: 'Shared Account',
    isOnlyForCurrentLocation: 'Only for Current Location',
    isCashierRegister: 'Cashier Register',
    isTransactional: 'Transactional',
    parentAccountID: 'Parent Account',
    debit: 'Debit',
    credit: 'Credit'
  },
  ar: {
    id: 'ID',
    enName: 'اسم الحساب بالانكليزي',
    arName: 'اسم الحساب بالعربي',
    enDescription: 'الوصف الانكليزي',
    arDescription: 'الوصف العربي',
    code: 'الرمز',
    accountCategory: 'فئة الحساب',
    accountSubcategory: 'الفئة الفرعية',
    balance: 'نوع الرصيد',
    isSharedAccount: 'حساب مشترك',
    isOnlyForCurrentLocation: 'للموقع الحالي فقط',
    isCashierRegister: 'حساب صندوق',
    isTransactional: 'حساب معاملات',
    parentAccountID: 'الحساب الأب',
    debit: 'مدين',
    credit: 'دائن'
  }
}

export enum AccountCategory {
  Assets = 'assets',
  Liabilities = 'liabilities',
  Equity = 'equity',
  Revenue = 'revenue',
  Expenses = 'expenses'
}

export class AccountTemplate extends UUIDBase {
  static ENDPOINT = '/accounting/accounts/templates'

  parentAccountID = ''

  enName = ''
  arName = ''

  code?: number
  arDescription?: string
  enDescription?: string
  accountCategory?: AccountCategory
  accountSubcategory?: string
  balance?: 'debit' | 'credit'
  isSharedAccount = true
  isOnlyForCurrentLocation = false
  isCashierRegister = false
  isTransactional = true

  static from(json: Record<string, unknown> | AccountTemplate) {
    const a = Object.assign(new AccountTemplate(), json)
    return a
  }
}
